// Admin API: the generic endpoint surface lives in @booking/core-ui/admin/api.
// Fudousan wires it to the admin token store + i18n and adds no vertical
// endpoints, so the rest of admin keeps importing `api` etc. from "@/lib/api".
import {
  getAccessToken,
  clearTokens,
  getTokens,
  saveTokens,
  isTokenExpired,
  parseJwtPayload,
  getClientType,
} from "./auth";
import { getTranslations } from "./i18n/context";
import { createAdminApi } from "@booking/core-ui/admin/api";
import { registerAdminRuntime } from "@booking/core-ui/admin/runtime";

const core = createAdminApi({
  getAccessToken,
  getTokens,
  saveTokens,
  clearTokens,
  isTokenExpired,
  parseJwtPayload,
  getClientType,
  translate: (key, params) => getTranslations()(key, params),
});

export const { api, setOnSessionExpired, getValidAccessToken, ensureSessionOrRedirect, getCurrentUser } = core;

// Inject the app runtime so shared admin components/pages can reach the api.
registerAdminRuntime({
  api,
  getValidAccessToken,
  ensureSessionOrRedirect,
  getCurrentUser,
  setOnSessionExpired,
  clearTokens,
  getIdToken: () => getTokens()?.id_token ?? null,

  /*
    The サービス checkboxes in the shared staff edit modal.

    staff_services has been in the schema since the init migration, PATCH
    /api/admin/staff has always accepted serviceIds, and StaffForService has
    always joined on it to decide who is offered for a booking. The form control
    was the only missing piece, in every vertical -- so the rows visible in the
    staff list until now came from the seed and nothing could change them.

    No request to read the selection: the staff payload already embeds `services`,
    so the row in hand is the answer. The save is a second PATCH carrying only
    serviceIds, which is safe because UpdateStaff COALESCEs every column it was
    not given -- see the query. Gym registers plans here instead; the section is
    one per vertical.
  */
  staffLinks: {
    loadOptions: async () =>
      (await api.services.list()).map((s) => ({ id: s.id, name: s.name })),
    loadSelection: async (staff) => (staff.services ?? []).map((sv) => sv.service.id),
    save: async (staffId, serviceIds) => {
      await api.staff.update(staffId, { serviceIds });
    },
  },
});
